<template>
  <BreadCrumb PageTitle="Ajouter Bon d'envoie ( SIMPLE )" />
  <AddNote />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddNote from "@/components/Notes/SentNotes/AddNote.vue";

export default defineComponent({
  name: "AddNotePage",
  components: {
    BreadCrumb,
    AddNote,
  },
});
</script>